// angular import
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PrimeNG } from 'primeng/config';
import { SpinnerComponent } from './theme/shared/components/spinner/spinner.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ErrorModalComponent } from '@shared/ui/error-modal/error-modal.component';
import { ErrorHandlerService } from './shared/data-access/error/error-handler.service';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	imports: [RouterOutlet, SpinnerComponent, ConfirmDialogModule, ToastModule, ErrorModalComponent],
	providers: [ConfirmationService, MessageService]
})
export class AppComponent implements OnInit {
	//private primengConfig = inject(PrimeNG);
	// public props
	private document = inject(DOCUMENT);
	title = 'wipa-web';
	@ViewChild('errorModal') errorModal!: ErrorModalComponent;

	constructor(
		private primeng: PrimeNG,
		private errorHandler: ErrorHandlerService
	) {}

	ngOnInit() {
		this.primeng.ripple.set(true);
		this.errorHandler.setModalRef(() => this.errorModal);
		if (!this.document.getElementById('google-maps-script')) {
			const script = this.document.createElement('script');
			script.id = 'google-maps-script';
			// Usamos la clave del environment para construir la URL
			script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}`;
			this.document.head.appendChild(script);
		}
		this.loadGoogleMapsScript();
	}
	private loadGoogleMapsScript(): void {
		if (!document.querySelector(`script[src*="maps.googleapis.com/maps/api/js"]`)) {
			const script = document.createElement('script');
			script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&libraries=places,geometry`;
			script.async = true;
			script.defer = true;
			script.onload = () => {
				console.log('Google Maps API script loaded dynamically.');
			};
			document.head.appendChild(script);
		}
	}
}
